import { EditorSerializer } from "@smartsuite/smartdoc";
import type { EditorSerializerProps } from "@smartsuite/smartdoc/lib/esm/react/EditorSerializer/EditorSerializer";
import type React from "react";

import {
  fullPresetExtensions,
  usePublicEditorExtensions,
} from "../../helpers/publicMentionExtension";

const HTMLBlockSerializer: React.FC<EditorSerializerProps> = (props) => {
  const extensions = usePublicEditorExtensions(fullPresetExtensions);
  return <EditorSerializer extensions={extensions} {...props} className="ProseMirror--forms" />;
};

export default HTMLBlockSerializer;
